import React from "react";
import { Link } from "react-router-dom";

const LOGOS = [
  { src: "/logos/nexist.png", alt: "Nexist", cls: "h-7 md:h-8", to: "/case-study/nexist" },
  { src: "/logos/unpopular.png", alt: "Unpopular You", cls: "h-6 md:h-7", to: "/case-study/unpopular-you" },
  { src: "/logos/outsourced.png", alt: "Outsourced Bookkeeping", cls: "h-7 md:h-8", to: "#work" },
  { src: "/logos/socialite.png", alt: "Socialite", cls: "h-7 md:h-8", to: "#work" },
  { src: "/logos/suttons.png", alt: "Suttons Bakery", cls: "h-10 md:h-11", to: "/case-study/suttons-bakery" },
];

export const ClientLogos = () => {
  const row = [...LOGOS, ...LOGOS, ...LOGOS];
  return (
    <section
      aria-label="Selected clients"
      className="relative w-full overflow-hidden py-8 md:py-10 border-t border-charcoal/5"
      data-testid="client-logos"
    >
      <div className="logo-marquee-track items-center">
        {row.map((l, i) => {
          const img = (
            <img
              src={l.src}
              alt={l.alt}
              loading="lazy"
              decoding="async"
              className={`${l.cls} w-auto object-contain grayscale opacity-40 group-hover:opacity-70 transition-opacity duration-300 select-none`}
            />
          );
          return (
            <span key={i} className="inline-flex items-center justify-center px-10 md:px-16 flex-shrink-0">
              {l.to.startsWith("#") ? (
                <a
                  href={l.to}
                  aria-label={`${l.alt} — view work`}
                  className="group inline-flex"
                  data-testid={`logo-link-${l.alt.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(l.to)?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  {img}
                </a>
              ) : (
                <Link
                  to={l.to}
                  aria-label={`${l.alt} case study`}
                  className="group inline-flex"
                  data-testid={`logo-link-${l.alt.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {img}
                </Link>
              )}
            </span>
          );
        })}
      </div>
      {/* edge fade */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-cream to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-cream to-transparent" />
    </section>
  );
};
